import { render, staticRenderFns } from "./PHSTooltipDialog.vue?vue&type=template&id=337f151d&scoped=true&"
import script from "./PHSTooltipDialog.vue?vue&type=script&lang=js&"
export * from "./PHSTooltipDialog.vue?vue&type=script&lang=js&"
import style0 from "./PHSTooltipDialog.vue?vue&type=style&index=0&id=337f151d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337f151d",
  null
  
)

export default component.exports